import styled from 'styled-components';
export const UIFormControlWrapper = styled.div.withConfig({
  displayName: "UIInputWrapperstyle__UIFormControlWrapper"
})(["min-width:", ";input,textarea{padding:", ";height:", ";border-color:", ";background-color:", ";outline:", ";font-size:", ";line-height:", ";border-bottom-color:", ";border-radius:", ";", ";}"], ({
  editMode
}) => editMode ? '200px' : 'unset', ({
  editMode,
  theme
}) => {
  const {
    space
  } = theme;
  if (editMode) return `${space['0']} ${space['0']} ${space['100']} ${space['0']}`;
  return `${space['200']} ${space['300']}`;
}, ({
  editMode,
  theme
}) => editMode ? 'unset' : theme.space['1000'], ({
  editMode,
  theme
}) => editMode ? 'transparent' : theme.color['fill-tertiary-pressed'], ({
  editMode,
  theme
}) => editMode ? 'unset' : theme.color['fill-surface-raised'], ({
  editMode
}) => editMode ? 'none' : 'unset', ({
  editMode,
  theme
}) => editMode ? theme.typography['body-125'].fontSize : theme.typography['body-200'].fontSize, ({
  editMode,
  theme
}) => editMode ? theme.typography['detail-100'].lineHeight : theme.typography['body-125'].lineHeight, ({
  editMode,
  theme
}) => {
  if (editMode) return theme.color['border-core-default'];
  return theme.color['fill-tertiary-pressed'];
}, ({
  editMode,
  theme
}) => editMode ? theme.borderRadius['0'] : theme.borderRadius['100'], ({
  editMode,
  theme
}) => editMode ? `
      &:focus {
        box-shadow: none;
        border-top-color: transparent;
        border-left-color: transparent;
        border-right-color: transparent;
        border-bottom-color: ${theme.color['border-core-default']};
      }
    ` : '');